import * as factory from '../../../iawp/src/js/factory'

if (!!document.querySelector('#newsletterForm')) {
    document.querySelectorAll('#newsletterForm').forEach(form => {
        new factory.IAForm(form, true, {
            rules: {
                email: {
                    required: true,
                    email: true
                }
            },
            messagesIdClass: '#newsletterForm'
        }).formInside(true)
        form.querySelector('[type="submit"]').addEventListener('click', e => {
            if(form.querySelector('input[name="email"]').value == '' || form.querySelector('input[name="email"]').classList.contains('error')){
                form.querySelector('input[name="email"]').focus()
            }
        })
    })
}
if (!!document.querySelector('.js-ia-blocks-form')) {
    document.querySelectorAll('.js-ia-blocks-form').forEach(form => {
        new factory.IAForm(form, true, {
            rules: {
                email: {
                    required: true,
                    email: true
                }
            },
            messagesIdClass: '.contactForm'
        }).formInside(true)
    })
}
if (!!document.querySelector('.captcha-option')) {
    document.querySelectorAll('.captcha-option input').forEach(captchaOption => {
        captchaOption.addEventListener('click', (evt) => {
            let that = evt.currentTarget
            let target = document.getElementById(evt.currentTarget.getAttribute('data-target'))

            if (that.checked) {
                target.value = that.value
            } else {
                target.value = ''
            }
            target.dispatchEvent(new Event('change'))
        })
    })
}